import { render } from "./DepremKarsilastirma.vue?vue&type=template&id=e9f452a2"
import script from "./DepremKarsilastirma.vue?vue&type=script&lang=js"
export * from "./DepremKarsilastirma.vue?vue&type=script&lang=js"

import "./DepremKarsilastirma.vue?vue&type=style&index=0&id=e9f452a2&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__